import Icon from '../components/Icon.vue'

Icon.register({
  envelope: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.3 190.8C506.2 187.7 512 190.6 512 195.5V400C512 426.5 490.5 448 464 448H48C21.5 448 0 426.5 0 400V195.6C0 190.6 5.7 187.8 9.7 190.9 32.1 208.3 61.8 230.4 163.8 304.5 184.9 319.9 220.5 352.3 256 352.1 291.7 352.4 328 319.3 348.3 304.5 450.3 230.4 479.9 208.2 502.3 190.8zM256 320C279.2 320.4 312.6 290.8 329.4 278.6 462.1 182.3 472.2 173.9 502.8 149.9 508.6 145.4 512 138.4 512 131V112C512 85.5 490.5 64 464 64H48C21.5 64 0 85.5 0 112V131C0 138.4 3.4 145.3 9.2 149.9 39.8 173.8 49.9 182.3 182.6 278.6 199.4 290.8 232.8 320.4 256 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/envelope.js
// module id = OHUv
// module chunks = 144